module.exports = ReduxThunk;


//////////////////
// WEBPACK FOOTER
// external "ReduxThunk"
// module id = 79
// module chunks = 0